import React from "react";
import { Checkbox } from "@mui/material";

type SelectAllCheckboxProps = {
  checked: boolean;
  indeterminate: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

/** Presentational header checkbox for invoice line-item Select All. */
const SelectAllCheckbox: React.FC<SelectAllCheckboxProps> = ({
  checked,
  indeterminate,
  disabled = false,
  onChange,
}) => (
  <Checkbox
    sx={{ border: "1px solid #ffffff", color: "common.white", "&.Mui-checked": { color: "common.white" }, "&.MuiCheckbox-indeterminate": { color: "common.white" } }}
    checked={checked}
    indeterminate={indeterminate}
    disabled={disabled}
    onChange={(e) => onChange(e.target.checked)}
    inputProps={{ "aria-label": "Select all products" }}
  />
);

export default SelectAllCheckbox;
